<template>
  <div class="my-4">
    <div
      class="flex mx--2 flex-row my-4px"
      v-for="index in customFieldStrings.map((_, i) => i).filter((i) => i % 2 === 0)"
      :key="index"
    >
      <div class="w-1/2">
        <div
          v-if="
            isListStringField(customFieldStrings[index]?.fieldType) && Array.isArray(customFieldStrings[index]?.value)
          "
          class="value"
        >
          <div class="label-box" style="margin-bottom: 0px; cursor: pointer;" @click="handleListStringClick(index)">
            <BarcodeRow
              labelWidth="40"
              :label="customFieldStrings[index]?.label"
              :hidden="customFieldStrings[index]?.hidden"
              :value="`${getListStringLength(index)} items`"
            />
          </div>
        </div>
        <BarcodeRow v-else v-bind="renderBarcodeRow(index)" />
      </div>
      <div class="w-1/2" v-if="customFieldStrings[index + 1]">
        <div
          v-if="
            isListStringField(customFieldStrings[index + 1]?.fieldType) &&
              Array.isArray(customFieldStrings[index + 1]?.value)
          "
          class="value"
        >
          <div class="label-box" style="margin-bottom: 0px; cursor: pointer;" @click="handleListStringClick(index + 1)">
            <BarcodeRow
              labelWidth="40"
              :label="customFieldStrings[index + 1]?.label"
              :hidden="customFieldStrings[index + 1]?.hidden"
              :value="`${getListStringLength(index + 1)} items`"
            />
          </div>
        </div>
        <BarcodeRow v-else v-bind="renderBarcodeRow(index + 1)" />
      </div>
    </div>
    <div class="flex mx--2 flex-row my-4px" v-for="index in customFieldAdjustments.map((_, i) => i)" :key="index">
      <div class="w-full">
        <BarcodeRowAdjustment
          :labelWidth="40"
          :label="customFieldAdjustments[index]?.label"
          :customFieldKey="customFieldAdjustments[index]?.key"
          :adjustment="customFieldAdjustments[index]?.adjustment"
          :currentValue="customFieldAdjustments[index]?.currentValue"
        />
      </div>
    </div>
    <div class="flex mx--2 flex-row my-4px" v-if="customFieldEsigns.length > 0">
      <div class="w-1/2">
        <BarcodeRowEsign :labelWidth="40" :customFieldImages="customFieldEsigns" />
      </div>
    </div>
    <div
      class="flex mx--2 flex-row my-4px"
      v-for="index in customFieldImages.map((_, i) => i).filter((i) => i % 2 === 0)"
      :key="index"
    >
      <div class="w-1/2">
        <BarcodeRowImage
          :labelWidth="40"
          :label="customFieldImages[index]?.label"
          :hidden="customFieldImages[index]?.hidden"
          :values="customFieldImages[index]?.files"
        />
      </div>
      <div class="w-1/2" v-if="customFieldImages?.[index + 1]">
        <BarcodeRowImage
          :labelWidth="40"
          :label="customFieldImages[index + 1]?.label"
          :hidden="customFieldImages[index + 1]?.hidden"
          :values="customFieldImages[index + 1]?.files"
        />
      </div>
    </div>
    <div class="flex mx--2 flex-row my-4px" v-for="index in customFieldFiles.map((_, i) => i)" :key="index">
      <div class="w-full">
        <BarcodeRowMulti
          :labelWidth="40"
          :label="customFieldFiles[index]?.label"
          :hidden="customFieldFiles[index]?.hidden"
          :values="customFieldFiles[index]?.files"
        />
      </div>
    </div>

    <div class="flex mx--2 flex-row my-4px" v-for="index in customFieldReferences.map((_, i) => i)" :key="index">
      <div
        class="w-full"
        v-if="customFieldReferences?.[index]?.files?.[0]?.url || customFieldReferences?.[index]?.text"
      >
        <div v-if="!customFieldReferences?.[index]?.text" class="w-full">
          <BarcodeRowMulti
            :labelWidth="40"
            :label="customFieldReferences[index]?.label"
            :hidden="customFieldReferences[index]?.hidden"
            :values="customFieldReferences[index]?.files"
          />
        </div>
        <div class="flex mx--2 flex-row my-4px" v-else>
          <div class="w-1/2">
            <BarcodeRow v-bind="renderBarcodeRowReference(index)" />
          </div>
          <div class="w-1/2" v-if="customFieldReferences[index + 1]">
            <BarcodeRow v-bind="renderBarcodeRowReference(index + 1)" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- List String Modal -->
  <el-dialog
    v-model="listStringModalVisible"
    :title="currentFieldLabel"
    width="100%"
    center
    custom-class="list-string-modal"
    :show-close="false"
  >
    <div>
      <div style="margin-bottom: 16px; font-weight: bold;">
        Total: {{ listStringData.length }} {{ listStringData.length === 1 ? 'item' : 'items' }}
      </div>
      <div style="max-height: 400px; overflow-y: auto;">
        <table style="width: 100%; border-collapse: collapse;">
          <tbody>
            <tr v-for="(item, index) in listStringData" :key="index">
              <td style="border: 1px solid #ddd; padding: 8px;">#{{ index + 1 }}</td>
              <td style="border: 1px solid #ddd; padding: 8px;">{{ item.value }}</td>
              <td style="border: 1px solid #ddd; padding: 8px;">{{ formatDateTime(item.createdDateTime) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #footer>
      <el-button @click="listStringModalVisible = false" type="primary">
        OK
      </el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import BarcodeRow from '@/components/barcode/BarcodeRow.vue'
import BarcodeRowAdjustment from '@/components/barcode/BarcodeRowAdjustment.vue'
import BarcodeRowEsign from '@/components/barcode/BarcodeRowEsign.vue'
import BarcodeRowImage from '@/components/barcode/BarcodeRowImage.vue'
import BarcodeRowMulti from '@/components/barcode/BarcodeRowMulti.vue'
import { CUSTOM_FIELD_KEY, TIMETABLE_DATETIME } from '@/utils/constants'
import moment from 'moment'
import { format } from 'date-fns'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
// import { EFileKind } from '@/utils/enums'
import {
  IBarcodeCustomField,
  ICustomFieldFileView,
  IFileItem,
  IListStringItem,
  IProjectCustomField,
} from '@/utils/types'
import { EFileKind } from '@/utils/enums'

export interface IField {
  label: string
  value: string | string[] | IListStringItem[]
  hidden: boolean
  fieldType?: string
}

@Options({
  components: { BarcodeRow, BarcodeRowImage, BarcodeRowMulti, BarcodeRowEsign, BarcodeRowAdjustment },
  name: 'BarcodeCustomField',
})
export default class BarcodeCustomField extends Vue {
  @Prop({ type: Object }) readonly barcodeCustomFields!: Record<string, IBarcodeCustomField>
  @Prop({ type: Object }) readonly projectCustomFields!: Record<string, IProjectCustomField>

  listStringModalVisible = false
  listStringData: IListStringItem[] = []
  currentFieldLabel = ''

  get customFieldStrings() {
    const customFields = [] as IField[]
    for (const key in this.barcodeCustomFields) {
      if (this.projectCustomFields?.[key]) {
        let value: string | string[] | IListStringItem[] = ''
        const fieldType = this.barcodeCustomFields[key].fieldType
        switch (fieldType) {
          case CUSTOM_FIELD_KEY.text:
            value = this.barcodeCustomFields[key]?.text || ''
            break
          case CUSTOM_FIELD_KEY.number:
            value = (this.barcodeCustomFields[key]?.number || '').toString()
            break
          case CUSTOM_FIELD_KEY.singleSelect:
            value = this.barcodeCustomFields[key]?.singleSelect?.value || ''
            break
          case CUSTOM_FIELD_KEY.multiSelect:
            value = (this.barcodeCustomFields[key]?.multiSelect || []).map((item) => item.value).join(', ')
            break
          case CUSTOM_FIELD_KEY.date:
            value = this.barcodeCustomFields[key]?.date || ''
            break
          case CUSTOM_FIELD_KEY.dateTimeData:
            value = this.barcodeCustomFields[key]?.dateTimeData
              ? moment(this.barcodeCustomFields[key]?.dateTimeData)
                  .local()
                  .format(TIMETABLE_DATETIME.DATE_TIME_FULL_FORMAT)
              : ''
            break
          case CUSTOM_FIELD_KEY.phoneNumber:
            value = this.barcodeCustomFields[key]?.phoneNumber?.number || ''
            break
          case CUSTOM_FIELD_KEY.email:
            value = this.barcodeCustomFields[key]?.email || ''
            break
          case CUSTOM_FIELD_KEY.listString:
            value = ((this.barcodeCustomFields[key]?.listString || []) as unknown) as IListStringItem[]
            break
        }
        if (value && (Array.isArray(value) ? value.length > 0 : value !== '')) {
          customFields.push({
            label: this.projectCustomFields?.[key].label,
            hidden: !!this.projectCustomFields?.[key].isHidden,
            value,
            fieldType,
          })
        }
      }
    }

    return customFields
  }

  isListStringField(fieldType?: string) {
    return fieldType === CUSTOM_FIELD_KEY.listString
  }

  showListStringModal(value: IListStringItem[], label: string) {
    if (Array.isArray(value)) {
      this.listStringData = value.map((item) => {
        if (typeof item === 'string') {
          return {
            code: item,
            limitAmount: undefined,
            currentAmount: undefined,
            unit: undefined,
            createdDateTime: undefined,
          }
        }
        return item
      })
    } else {
      this.listStringData = []
    }
    this.currentFieldLabel = label
    this.listStringModalVisible = true
  }

  formatDateTime(dateTime: string) {
    if (!dateTime) return ''
    try {
      return format(new Date(dateTime), 'yyyy/MM/dd HH:mm:ss')
    } catch (error) {
      return dateTime
    }
  }

  getListStringLength(index: number): number {
    const field = this.customFieldStrings[index]
    if (field && Array.isArray(field.value)) {
      return field.value.length
    }
    return 0
  }

  handleListStringClick(index: number) {
    const field = this.customFieldStrings[index]
    if (field && Array.isArray(field.value)) {
      this.showListStringModal(field.value as IListStringItem[], field.label)
    }
  }

  get customFieldAdjustments() {
    const customFields = [] as Array<Record<string, string>>
    if (this.barcodeCustomFields) {
      const adjustments = Object.entries(this.barcodeCustomFields).filter(
        (item) => item[1].fieldType === CUSTOM_FIELD_KEY.adjustment
      )
      adjustments.forEach((item) => {
        const cf = {
          key: item[0],
          label: this.projectCustomFields[item[0]].label,
          adjustment: '',
          currentValue: '',
        }
        if (item[1].adjustment) {
          cf.adjustment = item[1].adjustment.toString()
        }
        if (item[1].currentValue) {
          cf.currentValue = item[1].currentValue.toString()
        }
        customFields.push(cf)
      })
    }
    return customFields
  }

  get customFieldEsigns() {
    const customFields = [] as Array<Record<string, string>>
    if (this.barcodeCustomFields) {
      const eSigns = Object.entries(this.barcodeCustomFields).filter(
        (item) => item[1].fieldType === CUSTOM_FIELD_KEY.eSign
      )
      eSigns.forEach((item) => {
        if (item[1].eSign) {
          customFields.push({
            label: this.projectCustomFields[item[0]].label,
            value: item[1].eSign || '',
          })
        }
      })
    }
    return customFields
  }

  get customFieldImages() {
    const customFields = [] as Array<ICustomFieldFileView & { hidden: boolean }>
    if (this.barcodeCustomFields) {
      const files = Object.entries(this.barcodeCustomFields).filter(
        (item) => item[1].fieldType === CUSTOM_FIELD_KEY.files
      )
      files.forEach((item) => {
        if (item[1]?.files && item[1]?.files.length > 0) {
          const file = this.projectCustomFields?.[item[0]]
          if (file.label && file.fileKind === EFileKind.IMAGE) {
            customFields.push({
              label: this.projectCustomFields?.[item[0]].label,
              files: item[1]?.files || [],
              hidden: !!this.projectCustomFields?.[item[0]].isHidden,
            })
          }
        }
      })
    }

    return customFields
  }

  get customFieldFiles() {
    const customFields = [] as Array<ICustomFieldFileView & { hidden: boolean }>
    if (this.barcodeCustomFields) {
      const files = Object.entries(this.barcodeCustomFields).filter(
        (item) => item[1].fieldType === CUSTOM_FIELD_KEY.files
      )
      files.forEach((item) => {
        if (item[1]?.files && item[1]?.files.length > 0) {
          const file = this.projectCustomFields?.[item[0]]
          if (file.label && file.fileKind !== EFileKind.IMAGE) {
            customFields.push({
              label: this.projectCustomFields?.[item[0]].label,
              files: item[1]?.files || [],
              hidden: !!this.projectCustomFields?.[item[0]].isHidden,
            })
          }
        }
      })
    }

    return customFields
  }

  get customFieldReferences() {
    const customFields = [] as Array<ICustomFieldFileView & { hidden: boolean }>
    if (this.barcodeCustomFields) {
      const references = Object.entries(this.barcodeCustomFields).filter(
        (item) => item[1].fieldType === CUSTOM_FIELD_KEY.reference
      )
      references.forEach((item) => {
        if (item[1].reference) {
          const file = item?.[1]?.reference?.file || {
            path: '',
            url: '',
            name: '',
          }
          customFields.push({
            label: this.projectCustomFields[item[0]].label,
            text: item[1]?.reference.text,
            files: [file as IFileItem],
            hidden: !!this.projectCustomFields?.[item[0]].isHidden,
          })
        }
      })
    }
    return customFields
  }

  renderBarcodeRow(index: number) {
    const field = this.customFieldStrings[index]
    if (!field) return null

    return {
      labelWidth: 40,
      label: field.label,
      hidden: field.hidden,
      value: field.value,
    }
  }

  renderBarcodeRowReference(index: number) {
    const field = this.customFieldReferences[index]
    if (!field) return null

    return {
      labelWidth: 40,
      label: field.label,
      hidden: field.hidden,
      value: field.text,
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .list-string-modal {
  .el-dialog__header {
    padding-bottom: 0px;
  }
}
</style>
